import type { LandingWorkflowItem } from './landingContent';

interface PracticeWorkflowProps {
  label: string;
  items: readonly LandingWorkflowItem[];
}

export default function PracticeWorkflow({
  label,
  items,
}: PracticeWorkflowProps) {
  return (
    <section
      id="workflow"
      className="landing-workflow landing-support-section"
      aria-label={label}
    >
      <div className="landing-section-head">
        <h2>{label}</h2>
      </div>
      <ol className="landing-workflow-list">
        {items.map((item) => (
          <li key={item.number} className="landing-workflow-item">
            <span className="landing-workflow-number">{item.number}</span>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <p className="landing-workflow-outcome">{item.outcome}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
